import { 
    RETRIEVE_PROVIDER_PENDING, RETRIEVE_PROVIDER_FULFILLED, RETRIEVE_PROVIDER_REJECTED,
    UPDATE_PROVIDER_PENDING, UPDATE_PROVIDER_FULFILLED, UPDATE_PROVIDER_REJECTED,
    LIST_PROVIDER_PENDING, LIST_PROVIDER_FULFILLED, LIST_PROVIDER_REJECTED,
    ACCEPTED_PROVIDER_PENDING, ACCEPTED_PROVIDER_FULFILLED, ACCEPTED_PROVIDER_REJECTED,
    STAND_BY_PROVIDER_PENDING, STAND_BY_PROVIDER_FULFILLED, STAND_BY_PROVIDER_REJECTED,
    REFUSAL_PROVIDER_PENDING, REFUSAL_PROVIDER_FULFILLED, REFUSAL_PROVIDER_REJECTED,
    MEETING_PROVIDER_PENDING, MEETING_PROVIDER_FULFILLED, MEETING_PROVIDER_REJECTED,
    APPROVED_PROVIDER_PENDING, APPROVED_PROVIDER_FULFILLED, APPROVED_PROVIDER_REJECTED,
    CREATE_NEW_LEAD_PROVIDER_PENDING, CREATE_NEW_LEAD_PROVIDER_FULFILLED, CREATE_NEW_LEAD_PROVIDER_REJECTED,
    VALID_DOCUMENT_PENDING, VALID_DOCUMENT_FULFILLED, VALID_DOCUMENT_REJECTED
} from './ProviderConstants'


const INITIAL_STATE = {
    provider: { pending: false, fulfilled: false, error: null, provider:null },
    new: { pending: false, fulfilled: false, error: null, provider:null },
    list_provider: { pending: false, fulfilled: false, error: null, list:[] }, 
    status: { pending: false, fulfilled: false, error: null }, 
    document: { pending: false, fulfilled: false, error: null }, 
}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {

        // CREATE USER
        case RETRIEVE_PROVIDER_PENDING:
            return {...state, provider: { pending: true, fulfilled: false} }
        case RETRIEVE_PROVIDER_FULFILLED:
            return {...state, provider: { pending: false, fulfilled: true, provider:action.payload.data} }
        case RETRIEVE_PROVIDER_REJECTED:
            return {...state, provider: { pending: false, error: action.payload.response} }

        case UPDATE_PROVIDER_PENDING:
            return {...state, provider: { ...state.provider, pending: true, fulfilled: false} }
        case UPDATE_PROVIDER_FULFILLED:
            return {...state, provider: { ...state.provider, pending: false, fulfilled: true, provider:action.payload.data} }
        case UPDATE_PROVIDER_REJECTED:
            return {...state, provider: { ...state.provider, pending: false, error: action.payload.response} }

        case LIST_PROVIDER_PENDING:
            return {...state, list_provider: { ...state.list_provider, pending: true, fulfilled: false} }
        case LIST_PROVIDER_FULFILLED:
            return {...state, list_provider: { ...state.list_provider, pending: false, fulfilled: true, list:action.payload.data} }
        case LIST_PROVIDER_REJECTED:
            return {...state, list_provider: { ...state.list_provider, pending: false, error: action.payload.response} }

        case ACCEPTED_PROVIDER_PENDING:
            return {...state, status: { ...state.status, pending: true, fulfilled: false} }
        case ACCEPTED_PROVIDER_FULFILLED:
            return {...state, status: { ...state.status, pending: false, fulfilled: true} }
        case ACCEPTED_PROVIDER_REJECTED:
            return {...state, status: { ...state.status, pending: false, error: action.payload.response} }

        case STAND_BY_PROVIDER_PENDING:
            return {...state, status: { ...state.status, pending: true, fulfilled: false} }
        case STAND_BY_PROVIDER_FULFILLED:
            return {...state, status: { ...state.status, pending: false, fulfilled: true} }
        case STAND_BY_PROVIDER_REJECTED:
            return {...state, status: { ...state.status, pending: false, error: action.payload.response} }

        case REFUSAL_PROVIDER_PENDING:
            return {...state, status: { ...state.status, pending: true, fulfilled: false} }
        case REFUSAL_PROVIDER_FULFILLED:
            return {...state, status: { ...state.status, pending: false, fulfilled: true} }
        case REFUSAL_PROVIDER_REJECTED:
            return {...state, status: { ...state.status, pending: false, error: action.payload.response} }

        case MEETING_PROVIDER_PENDING:
            return {...state, status: { ...state.status, pending: true, fulfilled: false} }
        case MEETING_PROVIDER_FULFILLED:
            return {...state, status: { ...state.status, pending: false, fulfilled: true} }
        case MEETING_PROVIDER_REJECTED:
            return {...state, status: { ...state.status, pending: false, error: action.payload.response} }

        case APPROVED_PROVIDER_PENDING:
            return {...state, status: { ...state.status, pending: true, fulfilled: false} }
        case APPROVED_PROVIDER_FULFILLED:
            return {...state, status: { ...state.status, pending: false, fulfilled: true} }
        case APPROVED_PROVIDER_REJECTED:
            return {...state, status: { ...state.status, pending: false, error: action.payload.response} }

        case VALID_DOCUMENT_PENDING:
            return {...state, document: { ...state.document, pending: true, fulfilled: false} }
        case VALID_DOCUMENT_FULFILLED:
            return {...state, document: { ...state.document, pending: false, fulfilled: true} }
        case VALID_DOCUMENT_REJECTED:
            return {...state, document: { ...state.document, pending: false, error: action.payload.response} }


        case CREATE_NEW_LEAD_PROVIDER_PENDING:
            return {...state, new: { pending: true, fulfilled: false} }
        case CREATE_NEW_LEAD_PROVIDER_FULFILLED:
            return {...state, new: { pending: false, fulfilled: true, provider:action.payload.data.id} }
        case CREATE_NEW_LEAD_PROVIDER_REJECTED:
            return {...state, new: { pending: false, error: action.payload.response} }

        // DEFAULT
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/provider/ProviderReducer.js